import React from "react";
import XmlDealerUser from "../components/UI/reusable-components/XmlDealer/XmlDealerUser";

export const XmlDealerUsersPage = () => {
    return (
        <div>
            <XmlDealerUser />
        </div>
    )
}